import { config } from '../../config';
import { AuthRestriction } from './authentication.guard';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

export const playForFunGuard = (ipCountry: Country) => {
    let value = AuthRestriction.UNRESTRICTED;

    if (
        ipCountry &&
        config.gamePlay.playForFunBlockedCountries &&
        config.gamePlay.playForFunBlockedCountries.includes(ipCountry)
    ) {
        value = AuthRestriction.AUTH_REQUIRED;
    }

    return {
        authRestriction: value,
    };
};
